module.exports = __webpack_public_path__ + "static/hubspot-footer-04013bc1810d139cf6dc03e4a286329d.png";